import { FC, useCallback } from 'react'
import { FeatureAppLoader } from '@feature-hub/react'
import { Box, styled } from '@mui/material'
import { HEADER_HEIGHT } from '../../constants/styles'
import { getMfeBundleUrl } from '../../utils/assets'
import LoadingScreen from '../../react/components/LoadingScreen'
import ErrorPage from '../../react/components/ErrorPage'

const Container = styled(Box)({
  minHeight: `calc(100vh - ${HEADER_HEIGHT})`,
  width: '100%',
})

const StyledLoadingScreen = styled(LoadingScreen)({
  height: '100%',
  width: '100%',
})

const ErrorScreen = styled(ErrorPage)({
  height: '100%',
  width: '100%',
})

type Props = {
  mfeId: string
  port: string
}

const reportMfeError = (mfeId: string, src: string, error: Error): void => {
  console.error(`The Feature App with the ID "${mfeId}" could not be rendered.`, error)

  if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const Raven = require('raven-js')
    Raven.captureException(error, { extra: { mfeId, src } })
  }
}

const MfeLoader: FC<Props> = ({ mfeId, port }) => {
  const src = getMfeBundleUrl(port, mfeId)
  const handleError = useCallback((error: Error) => reportMfeError(mfeId, src, error), [mfeId, src])

  return (
    <Container>
      <FeatureAppLoader featureAppId={mfeId} src={src} onError={handleError}>
        {({ error, featureAppNode, loading }) => {
          if (error) {
            return <ErrorScreen returnToHomeLink="/" isServerError={false} />
          } else {
            return (
              <>
                <Box style={{ display: loading ? 'none' : 'initial' }}>{featureAppNode}</Box>
                {loading && <StyledLoadingScreen />}
              </>
            )
          }
        }}
      </FeatureAppLoader>
    </Container>
  )
}

export default MfeLoader
